var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.call !== null)?_c('div',{staticClass:"quality-info"},[_c('QualityInfo',{attrs:{"uid":_vm.uid}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }